import Map from './Map';

export default new class MapFilters {
    constructor() {
        this.mapForCatalogFiltersWrapper = '.map-for-catalog-filters-wrapper';
        this.mapForCatalogFiltersLegal = '.map-for-catalog-filters__legal';
        this.mapForCatalogFiltersAvailableDate = '.map-for-catalog-filters__available-date';

        this.obFiltersFlags = {
            legal: false,
            available: false
        };
        this.arProductIDList = [];
        this.iProductID = false;

        this.filterHandlers();
    }

    filterHandlers() {
        let _MapFilters = this;
        $(document).on('change', `${this.mapForCatalogFiltersLegal}, ${this.mapForCatalogFiltersAvailableDate}`, function(e) {
            e.preventDefault();
            e.stopPropagation();

            let _this = $(this),
                _filtersWrapper = _this.closest(_MapFilters.mapForCatalogFiltersWrapper);

            _MapFilters.obFiltersFlags.legal = _filtersWrapper.find(`${_MapFilters.mapForCatalogFiltersLegal} > input`).is(':checked');
            _MapFilters.obFiltersFlags.available = _filtersWrapper.find(`${_MapFilters.mapForCatalogFiltersAvailableDate} > input`).is(':checked');

            _MapFilters.filter();
        });
    }

    setProductIDList(arFilterIDList) {
        this.arProductIDList = arFilterIDList;
    }
    
    filter(firstLoad) {
        if(Object.keys(Map.map).length == 0) {
            return;
        }
        
        Map.clearMap();

        if(firstLoad) {
            this.obFiltersFlags = {
                legal: false,
                available: false
            };
        }

        let filteredMapItemsData = {};

        for(let i = 0; i <Map.mapItemsData.length; i++) {
            if(!Object.keys(Map.mapItemsData[i].products).length) {
                continue;
            }

            let obProducts = Map.mapItemsData[i].products;
            if(this.obFiltersFlags.legal && Map.mapItemsData[i].legal) {
                obProducts = {};
            }

            if(this.obFiltersFlags.available) {
                obProducts = this.filterByAvailable(obProducts);
            }
            
            //Применение фильтрации по товарам
            if($('.product-list-page').length > 0) {
                if(this.iProductID) {
                    obProducts = this.filterByProductID(obProducts);
                } else {
                    obProducts = this.filterByProductList(obProducts);
                }
            }
            
            if(!Object.keys(obProducts).length) {
                continue;
            }

            filteredMapItemsData[Map.mapItemsData[i].id] = /* for ie */ JSON.parse(JSON.stringify(Map.mapItemsData[i])); // Object.assign({}, Map.mapItemsData[i]);
            filteredMapItemsData[Map.mapItemsData[i].id].price = this.getMinPrice(obProducts);
            filteredMapItemsData[Map.mapItemsData[i].id].products = obProducts;
        }

        Map.mapsItems(filteredMapItemsData);
    }

    filterByLegal(obProduct) {
        if(!Object.keys(obProduct).length) {
            return {};
        }

        let obResult = {};
        for(let i in obProduct) {
            if(obProduct[i].legal) {
                obResult[obProduct[i].id] = obProduct[i];
            }
        }
        return obResult;
    }

    filterByAvailable(obProduct) {
        if(!Object.keys(obProduct).length) {
            return {};
        }

        let obResult = {};
        for(let i in obProduct) {
            if(!obProduct[i].available_date) {
                obResult[obProduct[i].id] = obProduct[i];
            }
        }
        return obResult;
    }

    /**
     * Фильтрация товаров для вывода на карте по списку ID товаров
     * @param obProductList
     * @returns {{}}
     */
    filterByProductList(obProductList) {

        if(!this.arProductIDList || this.arProductIDList.length == 0) {
            return {};
        }

        if(!Object.keys(obProductList).length) {
            return {};
        }

        let obResult = {};
        for(let iProductID in obProductList) {
            for(let i in this.arProductIDList) {
                if(iProductID == this.arProductIDList[i]) {
                    obResult[iProductID] = obProductList[iProductID];
                }
            }
        }

        return obResult;
    }

    /**
     * Фильтрация товаров для вывода на карте по ID товара
     * @param obProductList
     * @returns {{}}
     */
    filterByProductID(obProductList) {

        if(!this.iProductID) {
            return {};
        }

        if(!Object.keys(obProductList).length) {
            return {};
        }

        let obResult = {};
        for(let iProductID in obProductList) {
            if(iProductID == this.iProductID) {
                obResult[iProductID] = obProductList[iProductID];
            }
        }

        return obResult;
    }

    getMinPrice(obProducts) {
        let minPrice = null;

        for(let i in obProducts) {
            if(minPrice == null || minPrice > parseFloat(obProducts[i].price)) {
                minPrice = parseFloat(obProducts[i].price);
            }
        }
        return minPrice;
    }

};


// WEBPACK FOOTER //
// ./src/common/modules/MapClasses/MapFilters.js